import { useMetaContext } from '../base';
import { GeoChartHeader } from './GeoChartHeader/GeoChartHeader';
import { GeoChartBody } from './GeoChartBody/GeoChartBody';

export const GeoChartBase = () => {
    const meta = useMetaContext();

    return (
        <div
            style={{
                width: meta.container.width,
                height: meta.container.height,
            }}
        >
            <GeoChartHeader />
            <GeoChartBody />
        </div>
    );
};
